import React from 'react';
import './Researchpermission.css';

const EnglishPage = () => {
    return (
        <div>
            <p>
                <b>
                    <span lang="EN-US">
                        Information letter about research on self-evaluation of learning in research
                        ethics
                    </span>
                </b>
            </p>

            <p>
                <span lang="FEN-USI">
                    We, the developers of the Reflection Compass application, are researchers of
                    teaching and learning at the University of Helsinki, Faculty of Educational
                    Sciences. We would like to understand self-evaluation and its accuracy in the
                    context research ethics learning and would like to analyse the match between
                    students’ own understanding of research ethics and the open-ended answers they
                    provide. We are also interested in matches/mismatches between students’ own
                    estimation of their level of understanding of the topic and the teacher’s
                    possible estimation of the students’ level of understanding. We do not analyse
                    the learning tasks given by the teacher.
                </span>
            </p>

            <p>
                <span lang="EN-US">
                    Participation in the research is voluntary. First, we ask the teacher to allow
                    us the use of the information generated through this application. If the teacher
                    consents, the system sends a request to the students of the course. If the
                    teacher declines use of the information generated through the use of the
                    application, the system will not send a request to the students. Information
                    from students who have not consented, will not be used, even if the teacher
                    consented. Participation in research helps us develop research ethics education.
                </span>
            </p>

            <p>
                <span lang="EN-US">
                    References to specific individuals, places or institutions will be anonymized.
                    Researchers only work with anonymized data. The research follows the guidelines
                    of the Finnish National Board on Research Integrity. We will not disclose any
                    personal information, and we guarantee your anonymity in research reports and
                    scientific articles. We store all the data on password-protected accounts
                    associated with the University of Helsinki. If you wish to withdraw from the
                    research, you may do so at any point without providing a reason and without any
                    consequences to you. You may withdraw by contacting the e-mail address below.
                    Since the researchers work with anonymized data, it may not be possible to trace
                    your data after certain phases in the research process.
                </span>
            </p>

            <p>
                <span lang="EN-US">
                    Should you have any questions, please, do not hesitate to contact Erika Löfström
                    Erika.lofstrom@helsinki.fi
                </span>
            </p>

            <p>
                <b>
                    <span lang="EN-US">Consent</span>
                </b>
            </p>

            <p>I understand that</p>

            <p>
                <span lang="EN-US" className="p">
                    participation in research is voluntary, and I may terminate my participation at
                    any point without providing a reason
                </span>
            </p>

            <p>
                <span lang="EN-US" className="p">
                    I have the right to withdraw my consent and ask researchers to remove already
                    collected data. I understand that at this point the researchers may only have
                    anonymized data
                </span>
            </p>

            <p>
                <span lang="EN-US" className="p">
                    my identity or any information that could lead to the disclosure of my identity
                    will not be disposed by the researchers
                </span>
            </p>

            <p>
                <span lang="EN-US" className="p">
                    I can contact the researchers should I have questions about the research
                </span>
            </p>
        </div>
    );
};

export default EnglishPage;
